import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import { useParams } from 'react-router-dom';
import { categories } from '@/mocks/comics';
import HeroSection, { CategoryGrid } from './components/CategoryContent';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryName = category?.name || '漫画分类';

  const categorySchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${categoryName} - 虫虫漫画网`,
    description: category?.description || '虫虫漫画网漫画分类，下拉式完整版免费阅读',
    url: `https://www.chongchongmanhua.com/category/${slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '虫虫漫画网',
      url: 'https://www.chongchongmanhua.com',
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.chongchongmanhua.com' },
        {
          '@type': 'ListItem',
          position: 2,
          name: categoryName,
          item: `https://www.chongchongmanhua.com/category/${slug}`,
        },
      ],
    },
  };

  return (
    <>
      <SEOHead
        title={`${categoryName} - 下拉式完整版漫画免费阅读 | 虫虫漫画网`}
        description={
          category?.description ||
          '虫虫漫画网漫画分类页，下拉式完整版免费阅读，无删减韩国漫画，流畅下拉观看。'
        }
        keywords={`${categoryName},下拉式漫画,无删减漫画,免费阅读,韩国漫画,虫虫漫画网`}
        canonicalUrl={`https://www.chongchongmanhua.com/category/${slug}`}
        schema={categorySchema}
      />

      <Navbar />

      <main>
        <HeroSection categorySlug={slug || ''} />
        <CategoryGrid categorySlug={slug || ''} />
      </main>

      <Footer />
    </>
  );
}